import { defineMessage } from '@redbubble/next/intl';
import ex9Img from '../assets/models/ex9.png';
import { PreQuerySizeGuideData } from '../types';
import {
  howToChooseSizeTshirtInstructions,
  TSHIRT_ILLUSTRATION_PATH,
} from './sharedSizeGuideData';

/**
 * Experience 9
 * Boxy t-shirt
 * blockish-wrapper
 */

export const experience9: PreQuerySizeGuideData = {
  fitIndicator: {
    value: 8 /* 1 - 10 */,
  },
  howToChooseSize: {
    imageUrl: TSHIRT_ILLUSTRATION_PATH,
    instructions: howToChooseSizeTshirtInstructions,
  },
  model: {
    female: {
      imageUrl: ex9Img.src,
      // TBC with product
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size Small. She usually wears a size Small.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 160 cm / 5’3”',
        }),
        defineMessage({
          defaultMessage: 'Chest: 43 cm / 17”',
        }),
      ],
    },
  },
};
